export default __webpack_public_path__ + "static/media/OIP.1ff6964f.png";